import React, { useEffect, useLayoutEffect, useRef } from "react";
import styles from "../../css/heatmaps/AIPurposeModal.module.css";
import { ReactSVG } from "react-svg";
import wandIcon from "../../img/icons/wand.svg";
import { lockBodyScroll, unlockBodyScroll } from "../../utils/bodyScrollLock";
import { AIPURPOSE_OPTIONS } from "./aiPurposeOptions";
import CloseBtn from "../CloseBtn";
import ButtonBtn from "../buttons/ButtonBtn";

const OPTIONS = AIPURPOSE_OPTIONS;

const AIPurposeModal = ({
  selectedType,
  onChangeType,
  onConfirm,
  onClose,
  isSubmitting = false,
  bgOpacity = 0.8,
}) => {
  const cardRefs = useRef([]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    lockBodyScroll();
    return () => {
      window.removeEventListener("keydown", onKey);
      unlockBodyScroll();
    };
  }, [onClose]);

  // Equalize option card heights across rows to keep all boxes same height
  useLayoutEffect(() => {
    let rafId;
    const equalize = () => {
      let max = 0;
      cardRefs.current.forEach((el) => {
        if (!el) return;
        el.style.minHeight = ""; // reset to measure natural height
        max = Math.max(max, el.offsetHeight || 0);
      });
      cardRefs.current.forEach((el) => {
        if (!el) return;
        el.style.minHeight = max ? `${max}px` : "";
      });
    };
    rafId = requestAnimationFrame(equalize);
    const onResize = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(equalize);
    };
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      cancelAnimationFrame(rafId);
    };
  }, [selectedType]);

  return (
    <div
      className={styles.overlay}
      style={{ "--bg-opacity": bgOpacity }}
      onClick={onClose}
    >
      <CloseBtn />
      <div
        className={styles.modal}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className={styles.header}>
          <div className={styles.iconWrap} aria-hidden>
            <ReactSVG src={wandIcon} />
          </div>
          <div>
            <h3 className={styles.title}>AI analýza</h3>
            <p className={styles.subtitle}>
              Vyberte účel, podle kterého obsah vyhodnotíme.
            </p>
          </div>
        </div>

        <div className={styles.optionsGrid}>
          {OPTIONS.map((opt, idx) => {
            const active = selectedType === opt.key;
            return (
              <button
                key={opt.key}
                type="button"
                className={`${styles.optionCard} ${
                  active ? styles.active : ""
                }`}
                onClick={() => onChangeType?.(opt.key)}
                disabled={isSubmitting}
                ref={(el) => (cardRefs.current[idx] = el)}
              >
                <div className={styles.optionHeader}>
                  <span className={styles.optionTitle}>{opt.title}</span>
                  <span
                    className={`${styles.checkBadge} ${
                      active ? styles.badgeVisible : styles.badgeHidden
                    }`}
                    aria-hidden={!active}
                  >
                    Vybráno
                  </span>
                </div>
                <p className={styles.optionDesc}>{opt.desc}</p>
              </button>
            );
          })}
        </div>

        <div className={styles.actions}>
          {/* <button
            type="button"
            className={`btn delete`}
            onClick={onClose}
            disabled={isSubmitting}
          >
            Zrušit
          </button> */}
          <ButtonBtn
            type="button"
            className={styles.primaryBtn}
            onClick={onConfirm}
            disabled={isSubmitting}
            marginBlock="0"
            justifyContent="flex-end"
          >
            {isSubmitting ? "Odesílám…" : "Spustit analýzu za 1 kredit"}
          </ButtonBtn>
        </div>
      </div>
    </div>
  );
};

export default AIPurposeModal;
